export default "__VITE_ASSET__2d7f844b__"